module.exports = __webpack_public_path__ + "static/media/Decisions_Step5_Image24.f95a5ff3.webp";